import React from "react";
import styled, { keyframes } from "styled-components";
import { Icon } from "uikit";

import {
	StyledGrid,
	StyledGridItem,
	ButtonBase,
	BaseElementIdEnum,
} from "../common";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
`;

const Notification = styled.div<{ type: string; isExiting: boolean }>`
	position: fixed;
	right: 70px;
	background-color: ${(props) => {
		switch (props.type) {
			case "success":
				return "#52c41a";
			case "info":
				return "#1890ff";
			case "warn":
				return "#faad14";
			case "error":
				return "#f5222d";
			default:
				return "#ffffff";
		}
	}};
	color: #fff;
	padding: 16px;
	border-radius: 4px;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
	z-index: 1000;
	min-width: 300px;
	max-width: 400px;
	font-family: Arial, sans-serif;
	animation: ${(props) => (props.isExiting ? fadeOut : fadeIn)} 0.5s forwards;
`;

const Button = styled(ButtonBase)`
	width: 32px;
	height: 32px;
	color: #5e6b73;
	&:hover {
		color: #21333f;
	}
`;

const NotificationContainer: React.FC<NotificationContainer.Props> = ({
	type,
	message,
	description,
	style = {},
	isExiting = false,
	onClose,
	buttonCross,
}) => (
	<Notification type={type} style={style} isExiting={isExiting}>
		<StyledGrid
			areas={`'message btn'
					'description description'`}
		>
			<StyledGridItem area="btn">
				<Button
					onClick={onClose}
					cursor="pointer"
					variant="transpiration"
					id={BaseElementIdEnum.CROSS}
					{...buttonCross}
				>
					<Icon id="close-modal" size={12} />
				</Button>
			</StyledGridItem>
			<StyledGridItem area="message">
				<strong>{message}</strong>
			</StyledGridItem>
			<StyledGridItem area="description">
				<p>{description}</p>
			</StyledGridItem>
		</StyledGrid>
	</Notification>
);

declare namespace NotificationContainer {
	interface Props {
		type: "success" | "info" | "warn" | "error";
		message: string;
		description: string;
		style: React.CSSProperties;
		isExiting: boolean;
		buttonCross?: Partial<ButtonBase.Props>;
		onClose: (
			event?:
				| React.MouseEvent<HTMLButtonElement, MouseEvent>
				| KeyboardEvent,
		) => void;
	}
}

export default NotificationContainer;
